import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { ReferenceValue } from "@/entities/all";

export default function CreateValueModal({ isOpen, onClose, onValueCreated, listId }) {
  const [formData, setFormData] = useState({
    canonical_value: '',
    value_description: '',
    is_active: true
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await ReferenceValue.create({
        ...formData,
        list_id: listId
      });
      onValueCreated();
      setFormData({
        canonical_value: '',
        value_description: '',
        is_active: true
      });
    } catch (error) {
      console.error('Error creating reference value:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Add Reference Value</DialogTitle>
          <DialogDescription>
            Create a new canonical value for this reference list.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-6 mt-4">
          <div>
            <Label htmlFor="canonical_value">Canonical Value</Label>
            <Input
              id="canonical_value"
              value={formData.canonical_value}
              onChange={(e) => handleChange('canonical_value', e.target.value)}
              placeholder="e.g., ABC SHIPPING INC"
              required
            />
          </div>

          <div>
            <Label htmlFor="value_description">Description</Label>
            <Textarea
              id="value_description"
              value={formData.value_description}
              onChange={(e) => handleChange('value_description', e.target.value)}
              placeholder="Optional description of this value..."
              rows={3}
            />
          </div>

          <div className="flex items-center justify-between rounded-lg border p-4">
            <div className="space-y-0.5">
              <Label htmlFor="is_active">Active Status</Label>
              <p className="text-[0.8rem] text-muted-foreground">
                Whether this value is currently active and available for use.
              </p>
            </div>
            <Switch
              id="is_active"
              checked={formData.is_active}
              onCheckedChange={(checked) => handleChange('is_active', checked)}
            />
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Creating...' : 'Create Value'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}

